import React from 'react';
import styled from 'styled-components';
import { colorGrid } from 's2s-themes';

const BadgeContainer = styled.span`
  display : flex;
  position : relative;
`;

const BadgeText = styled.span`
  background-color : ${colorGrid.red5};
  border-radius : 50%;
  color: ${colorGrid.gray0};
  display: ${props => props.startNumber > 0 ? "inline" : "none"};
  font-size : 12px;
  height : 16px;
  line-height : 16px;
  position : absolute;
  left : 32px;
  text-align : center;
  top : 0px;
  width : 16px;
`;

const BigBadgeText = styled(BadgeText)`
  border-radius : 24px;
  width : 24px;
`;

const Badge = (startNumber=0, clickEventHandler=undefined ) => {
  return (WrappedComponent) => {

    const BadgedComponent = (props) => {

      const keyPress = (e) => {
        switch (e.keyCode){
          case 32:
            clickEventHandler();
            break;
          case 13:
            clickEventHandler();
            break;
          default:
            // do nothing
        }
      };

      // if number between 1 - 99 display number on badge else display 99+ on badge.
      let displayedStartNumber = startNumber <= 99 ? startNumber : "99+";
      // For styling purposes, if startNumber length has 2 or more digits switch styles so there is breathing room.
      const DynamicBadgeContainer = startNumber <= 10 ? BadgeText : BigBadgeText;

      let badgeDisplay; // if startNumber is 0 don't display badge at all
      if(startNumber > 0 ) {
        badgeDisplay = (
          <DynamicBadgeContainer 
            className="DynamicBadgeContainer" 
            startNumber={startNumber}
          >
            {displayedStartNumber}
          </DynamicBadgeContainer>);
      }

      return (
        <BadgeContainer
          aria-label='badge button'
          role='button'
          tabIndex='-1'
          onClick={clickEventHandler}
          onKeyDown={keyPress}
        >
          <WrappedComponent {...props} />
          {badgeDisplay}
        </BadgeContainer>
      );
    };
  return BadgedComponent;
  };
};

export default Badge;
